import React, { Component } from "react";
import { Navbar, Nav, NavItem, Image, Grid, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { slide as Menu } from "react-burger-menu";
import "./CustomNavbar.css";

export default class CustomNavbar extends Component {
  showSettings(event) {
    event.preventDefault();
  }
  render() {
    return (
      <Navbar default collapseOnSelect>
        <Navbar.Header>
          <Grid>
            <Row>
              <Col md={6} xs={6}>
                <Image
                  src="/assets/logo_transparent.png"
                  className={"navbar-logo-right "}
                />
              </Col>
              <Col md={6} xs={6}>
                <Image
                  src="/assets/logorb2_transparent.png"
                  className={"navbar-logo-left"}
                />
              </Col>
            </Row>
          </Grid>
          <Nav>
            <Menu width={"100%"} isOpen={false}>
              <div className="menustyle">
                <NavItem
                  eventKey={1}
                  componentClass={NavLink}
                  href="/home"
                  to="/home"
                >
                  Home
                </NavItem>
                <NavItem
                  eventKey={2}
                  componentClass={NavLink}
                  href="/howitworks"
                  to="/howitworks"
                >
                  How It Works
                </NavItem>
                <NavItem
                  eventKey={3}
                  componentClass={NavLink}
                  href="/wins"
                  to="/wins"
                >
                  Wins
                </NavItem>
                <NavItem
                  eventKey={4}
                  componentClass={NavLink}
                  href="/login"
                  to="/login"
                >
                  Login
                </NavItem>
                <NavItem
                  eventKey={5}
                  componentClass={NavLink}
                  href="/gameplan"
                  to="/gameplan"
                >
                  Gameplan
                </NavItem>
                <NavItem
                  eventKey={6}
                  componentClass={NavLink}
                  href="/agb"
                  to="/agb"
                >
                  AGB
                </NavItem>
                <NavItem
                  eventKey={7}
                  componentClass={NavLink}
                  href="/admin"
                  to="/admin"
                >
                  Admin
                </NavItem>
              </div>
            </Menu>
          </Nav>
        </Navbar.Header>
      </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomNavbar.jsx